<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="修改门店信息"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容部分 start-->
        <van-form ref="forms" style="margin-top: 1.5rem">
            <van-field
                    v-model="store_name"
                    label="门店名称"
                    required
                    name="门店名称"
                    clearable
                    placeholder="请输入门店名称"
                    :rules="[{ required: true, message: '门店名称不能为空' }]"
            />
			<van-field
			        v-model="store_contact"
			        label="门店联系人"
			        required
			        name="门店联系人"
			        clearable
			        placeholder="请输入门店联系人"
			        :rules="[{ required: true, message: '门店联系人不能为空' }]"
			/>
			<van-field
			        v-model="store_tel"
			        label="门店手机号"
			        required
			        name="门店手机号"
			        clearable
			        placeholder="请输入门店手机号"
			        :rules="[{ required: true, message: '门店手机号不能为空' }]"
			/>
			<van-field
			        v-model="store_info"
			        label="门店信息"
			        name="门店信息"
			        clearable
			        placeholder="请输入门店信息"
			/>
			<van-field name="uploader" label="门店图片" required :rules="[{ required: true, message: '门店图片不能为空' }]">
                <template #input>
                    <van-uploader :after-read="afterRead" v-model="imageList"   multiple :max-count="1"  />
                </template>
            </van-field>
			<van-field name="uploader" label="门店组图" required :rules="[{ required: true, message: '门店组图不能为空' }]">
			    <template #input>
			        <van-uploader :after-read="afterReads" v-model="imageLists" @delete="deletes" multiple  />
			    </template>
			</van-field>
			
			<van-field name="是否营业" label="是否营业" required :rules="[{ required: true, message: '是否营业必须选择' }]">
			    <template #input>
			        <van-radio-group v-model="store_is_start" direction="horizontal">
			            <van-radio :name="1">开业</van-radio>
			            <van-radio :name="0">暂停营业</van-radio>
			        </van-radio-group>
			    </template>
			</van-field>

        </van-form>
        <div style="margin: 16px;">
            <van-button @click="onSubmit" round block type="info" native-type="submit">
                确定
            </van-button>
        </div>
		
        <!--内容部分 end-->


    </div>
</template>

<script>
    // import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
	import Config from "../../../config";
    export default {
        name: "StoresStoreInformationUpdate",
        data() {
            return {
                imageList: [{url:''}],
                imageLists: [],
                store_contact:'',
                store_img:'',
				order_group_images:[],
                store_is_start:'',
                store_name:'',
                store_tel:'',
                store_info:'',
            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
		created(){
			this.merchant_id=this.$route.query.merchant_id;
			this.store_id=this.$route.query.store_id
			this.getStore()
		},
        methods: {
			getStore(res) {
			  this.$http
			    .get("/wechat/api.salesman/get_store_info", {
			      params: {
			        merchant_id: this.merchant_id,
			        store_id: this.store_id,
			      },
			    })
			    .then((response) => {
			      if (response && response.body.code== 200) {
			      	this.store_contact=response.body.data.store_contact
			      	this.store_is_start=response.body.data.store_is_start
			      	this.store_name=response.body.data.store_name
			      	this.store_tel=response.body.data.store_tel
			      	this.store_info=response.body.data.store_info
			      	if (response.body.data.store_img){
			      	    this.imageList[0].url=(Config.baseURL+response.body.data.store_img)
			      	    this.store_img=response.body.data.store_img
			      	}else{
			      	    this.imageList=[]
			      	    this.store_img=null
			      	}
					if (response.body.data.order_group_images){
						this.imageLists=[]
						response.body.data.order_group_images.map(item=>{
							let obj={url:Config.baseURL+item}
							this.imageLists.push(obj)
						})
					    
					    this.order_group_images=response.body.data.order_group_images
					}else{
					    this.imageLists=[]
					    this.order_group_images=null
					}
			      }
			    });
			},
			afterRead(file) {
                this.$http.post('/wechat/api.merchant/wechatUploadMerchantImg', {
                        localData:file.content,
                        openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.store_img=response.data.local_img
                    }
                })
            },
			afterReads(file) {
			    this.$http.post('/wechat/api.merchant/wechatUploadMerchantImg', {
			            localData:file.content,
			            openid: window.localStorage.getItem("openid")
			
			    }).then(response => {
			        if (response && response.data.code== 200) {
						this.order_group_images.push(response.data.local_img)
			        }
			    })
			},
			deletes(file,detail){
				this.order_group_images.splice(detail.index,1)
				
			},


            // 左侧返回
            onClickLeft() {
                this.$router.push({path:"/StoreInfo", query:{merchant_id:this.merchant_id,store_id:this.store_id}});
                // window.history.go(-1)
            },
            // 提交
            onSubmit() {
				// if(this.coupon_divide==''&&this.coupon_divide==null){
				//   this.coupon_divide=0;
				// }
                this.$refs.forms.validate().then(() => {
                    var toast = Toast.loading({
                        duration: 0,
                        message: '添加中',
                        forbidClick: true,
                        loadingType: 'spinner',
                    });
                    this.$http.post('/wechat/api.salesman/updateStore', {
						store_id:this.store_id,
						store_contact:this.store_contact,
						store_is_start:this.store_is_start,
						store_name:this.store_name,
						store_tel:this.store_tel,
						store_info:this.store_info,
						store_img:this.store_img,
						order_group_images:this.order_group_images,
						
                        // openid: window.localStorage.getItem("openid")
                    }).then(response => {
                        toast.clear();
                        if (response && response.data.code== 200) {

                            this.$router.push({path:"/StoreInfo", query:{merchant_id:this.merchant_id,store_id:this.store_id}});

                            // VueCookie.set('salesmanInfo', response.data.data, 360000);
                            // window.location.href = that.redirect;

                        }else{
                            Notify({type: 'danger', message: response.data.msg});
                        }
                    })

                }).catch(() => {
                    this.$toast.fail('必填项未填写')
                })
                // window.sessionStorage.setItem("tag",this.ta)
                //  var that = this;




            },
        },
    }
</script>

<style >
    .van-icon-goods-collect-o::before{
        position: relative;
        top: 0.1rem;
    }
    .van-icon-contact::before{
        position: relative;
        top: 0.1rem;
    }

    .van-field >>>.van-field__label{
        width: 30px;
    }
</style>
